import { createAction } from 'redux-actions';
var actionKey = 'WATCH_SUGGESTIONS';
export var unsuggestUser = createAction("".concat(actionKey, ".UNSUGGEST.USER"), function (payload) { return payload; });
//# sourceMappingURL=actions.js.map